import { render, staticRenderFns } from "./TrafficByOperatorTable.vue?vue&type=template&id=63cec5b0&scoped=true&"
import script from "./TrafficByOperatorTable.vue?vue&type=script&lang=js&"
export * from "./TrafficByOperatorTable.vue?vue&type=script&lang=js&"
import style0 from "./TrafficByOperatorTable.vue?vue&type=style&index=0&id=63cec5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cec5b0",
  null
  
)

export default component.exports